export default __webpack_public_path__ + "static/media/WallButton-On.1f44087a.png";